module.exports = __webpack_public_path__ + "img/engraving@2x.337dd56.webp";